import React from "react";

function MusicFeature() {
  return (
  <div>
    <section className="music-feature">
      <div className="container">
        <div className="music-feature-content">
          <h2 className="music-feature-title futuraPTBold">
            Feel the Music.
            <br />
            Live the Moment.
          </h2>

          <p className="music-feature-text">
            Experience unforgettable nights filled with incredible live
            performances, great food, and an electric atmosphere. From local
            favorites to rising stars and regional headliners, ADS Complex brings
            live music to the heart of our community. Grab a seat, bring your
            friends, and enjoy an evening where every show creates lasting
            memories.
          </p>

          <a href="/#upcoming-events" className="btn music-feature-button">
            View Upcoming Music Events
          </a>
        </div>
      </div>
    </section>
  </div>
  );
}

export default MusicFeature;
